// Structured Data (JSON-LD) utilities for SEO

interface Organization {
  '@context': 'https://schema.org';
  '@type': 'Organization';
  name: string;
  url: string;
  logo: string;
  description: string;
  foundingDate: string;
  contactPoint: {
    '@type': 'ContactPoint';
    telephone: string;
    contactType: 'customer service';
    availableLanguage: string[];
  };
  sameAs: string[];
}

interface SoftwareApplication {
  '@context': 'https://schema.org';
  '@type': 'SoftwareApplication';
  name: string;
  description: string;
  url: string;
  operatingSystem: string;
  applicationCategory: 'BusinessApplication';
  aggregateRating: {
    '@type': 'AggregateRating';
    ratingValue: string;
    reviewCount: string;
  };
}

interface WebSite {
  '@context': 'https://schema.org';
  '@type': 'WebSite';
  name: string;
  url: string;
  potentialAction: {
    '@type': 'SearchAction';
    target: {
      '@type': 'EntryPoint';
      urlTemplate: string;
    };
    'query-input': 'required name=search_term_string';
  };
}

export const getOrganizationStructuredData = (): Organization => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'MarketBetter.ai',
  url: 'https://marketbetter.ai',
  logo: 'https://marketbetter.ai/images/logo.png',
  description: 'AI-powered revenue engine that tracks high-intent buyers and automates multi-channel outreach',
  foundingDate: '2023',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-800-MARKET',
    contactType: 'customer service',
    availableLanguage: ['English']
  },
  sameAs: [
    'https://linkedin.com/company/marketbetter-ai',
    'https://twitter.com/marketbetter_ai'
  ]
});

export const getSoftwareApplicationStructuredData = (): SoftwareApplication => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'MarketBetter.ai Revenue Engine',
  description: 'Track high-intent buyers in real time, automate 5x faster multi-channel outreach, and convert leads with AI-powered workflows',
  url: 'https://marketbetter.ai',
  operatingSystem: 'Web Browser',
  applicationCategory: 'BusinessApplication',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    reviewCount: '150'
  }
});

export const getWebSiteStructuredData = (): WebSite => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'MarketBetter.ai',
  url: 'https://marketbetter.ai',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://marketbetter.ai/search?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
});

export const renderStructuredData = (data: Organization | SoftwareApplication | WebSite) => ({
  __html: JSON.stringify(data)
});
